<template>
  <div class="container">
  <div class="gk-admin-portal row">
    <div class="icon-logo" alt="Home"></div>
    <h2 style="font-family: 'Roboto Slab', serif;">NEIS Web Portal</h2>
  </div>
  <div class=" row justify-content-center">
    <div class="card w-50 login-panel">
      <div class="card-body">
        <h1>Log in</h1>

        <form @submit.prevent="login" autocomplete="off" >
          <span class="login-instruction">Sign in with NEIS credentials</span>
          <div v-if="error" class="alert alert-danger" role="alert">
            We couldn’t find an account matching the email and password you entered. Please check your email and password and try again.
          </div>

          <div class="form-group row">
            <!-- <label for="inputEmail3" class="col-sm-2 col-form-label">Email</label> -->
            <div class="col-sm-10">
              <input type="email" v-model="email" class="form-control" id="inputEmail3" placeholder="Email" >
            </div>
          </div>

          <div class="form-group row">
            <!-- <label for="inputPassword3" class="col-sm-2 col-form-label">Password</label> -->
            <div class="col-sm-10">
              <input type="password" v-model="password" class="form-control" id="inputPassword3" placeholder="Password">
            </div>
          </div>

          <div class="form-group row">
            <div class="col-sm-10">
              <router-link to="/forgot-password">Forgot Password</router-link>
              <button type="submit" class="btn btn-primary">Sign in</button>
            </div>
          </div>

        </form>

        </div>
        </div>
    </div>
  </div>
</template>

<script>
import { Config, PortalUser } from '../api';
import store from '../store'

export default {
    name: "login",
    data() {
      return {
        email: "",
        password: "",
        error: false
      }
    },
    props: [],
    methods: {
      async login(){
        this.error = false;

        let loggedIn = await store.dispatch('login', {
          username: this.email,
          password: this.password
        });

        if(loggedIn){
          this.$router.replace(this.$route.query.redirect || '/reports');
        }else{
          this.error = true;
	  console.log(password)
        }
      }
    },
    async beforeRouteEnter (to, from, next) {
        let loggedIn = await store.dispatch('initUser');
        next()        
    }
}
</script>

<style lang="scss" scoped>
@import "../css/constants";

//Reset row
.row {
  margin: 0;
}
.gk-admin-portal {
  font-family: 'Roboto Slab', serif;
  width: 52vw;
	display: flex;
	margin-top: -4rem;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  h2 {
    /* Administrator Portal: */
    font-weight: bold;
    font-size: $p20;
  }
}
.icon-logo{
  background-size: 12rem 12rem;
  width: 12rem;
  height: 12rem;
  margin: auto;
  margin-bottom: $p16;
  background-repeat: no-repeat;
}

.version-number {
  /* Rectangle: */
  font-size: $p14;
  padding: 6px 8px;
	padding-top: 8px;
	margin-top: $p16;
  color: $gray5;
  background: $gray2;
  border: 1px solid $gray4;
  border-radius: 4px;
}

.container {
  display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0;
	margin: 0;
	width: 100vw;
  background:$gray2;
}
input, input:focus {
  font-family: 'Roboto', sans-serif;
  width: 300px;
  padding-top: 10px;
  height: 40px;
}
.login-panel {
  width: 48vw;
  height: 100vh;
  justify-content: center;
  border: none;
  box-shadow: none;
  border-radius: 0;
  -webkit-clip-path: polygon(14% 0%, 100% 0, 100% 100%, 0% 100%);
  clip-path: polygon(14% 0%, 100% 0, 100% 100%, 0% 100%);

  /* Rectangle 35: */
  background-image: linear-gradient(-180deg, #56ccf2 0%, #2f80ed 100%);

  .card-body {
    font-family: 'Roboto Slab', serif;
    align-self: center;
    width: 300px;
    margin-left: $p52;
    margin-top: -3rem;
    justify-content: space-between;
    
    .alert{ margin-top: 15px; }
    .form-group {
      margin-top: $p16;
      margin-bottom: $p24;
    }
    a {
      color: white;

      // font-size: $p14;
      font-family: 'Roboto Slab', serif;
      font-weight: medium;
      font-size: 0.8em;
      // font-weight: 900;

      &:hover {
        color: white;
        cursor: pointer;
      }
    }

    h1{
        font-size: 40px;
        color: white;
        margin-bottom: 20px;
        text-align: center;
    }
  }
  .login-instruction {
    font-size: 1em;
    color: white;
    font-family: 'Roboto Slab', serif;
  }
}
.col-sm-10 {
  width: 300px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;
  padding: 0;
}

.btn-primary {
  border-radius: 100px;
	color: #243c98;
	padding: 9px $p40;
	padding-top: $p10;
  padding-left: $p24;
  padding-right: $p56;
	background: white;
	font-family: 'Roboto Slab', serif;
  font-weight: medium;
	border: none;
  background-image: url('../assets/sign-in-arrow.svg');
  background-size: $p20;
  background-position: 82px 11px;
  background-repeat: no-repeat;
  &:focus {
    box-shadow: none;
    outline: none;
  }
  &:active {
    background-color: white;
    color: $gkred;
  }
}

form{
  padding-top: 20px;
}
.alert-danger{
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
}

@media only screen and (max-width: 768px) {
  .gk-admin-portal{
    width: 100vw;
    height: 40vh;
    
    .icon-logo{
      margin-top: 5vh;
      margin-bottom: 10px;
    }
  }
  .container{
    display: flex;
    flex-direction: column;
  }

  .row{
    .login-panel{
      height: 60vh;
      width: 100vw;
      -webkit-clip-path: none;
      clip-path: none;

      .btn-primary{
        background-image: none;
      }
    }
  }
}

@media only screen and (max-width: 468px) {
  .gk-admin-portal{
    .icon-logo{
      background-size: 10rem 10rem;
      width: 10rem;
      height: 10rem;
    }
  }

  .row{
    .login-panel{
      h1{
        font-size: 30px;
        margin-bottom: 0px;
      }

      input{ width: 250px; }

      .form-container{
        padding-top: 10px;
      }

      .btn-primary{
        width: 130px;
        padding-left: 0;
        padding-right: 0;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Login.vue